import http from '../../../common/axios/axios.instance';
import { registerPushToken } from '../../../common/anonymousAuth';

export const sendOtp = (phoneNumber) => {
  return http.post('/api/v1/auth/send-otp', { phoneNumber }).then((response) => {
    return { phoneNumber, ...response };
  });
};

export const verifyOtp = ({ phoneNumber, otp }) => {
  return http.post('/api/v1/auth', { phoneNumber, otp }).then((response) => {
    if (response.data) {
      localStorage.setItem('userAuthToken', response.data);
      registerPushToken();
    }
    return response;
  });
};
